import * as React from 'react';
import { useSelector } from 'react-redux';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { navigateToPage } from '@cian/valuation-utils-component';

import { selectBonuses } from '../../selectors/promoInfo';
import { useModalWindowWithParams } from '../../utils/useModalWindowWithParams';
import { IBonus } from '../../types/promoInfo';
import { BonusesSection } from '../../components/BonusesSection';
import { BonusModal, IBonusModalExt } from '../../components/BonusModal';
import { trackBonusClicked, trackBonusViewed } from './tracking';
import { Section } from '../../components/Section';

/**
 * Секция бонусов и скидок.
 * Контент управляется с бэка. Может быть пустой.
 */
export const BonusesSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const bonuses = useSelector(selectBonuses);
  const [bonusModalProps, callBonusModal] = useModalWindowWithParams<IBonusModalExt>();

  const onBonusesViewed = () => {
    bonuses.forEach(bonus => trackBonusViewed(bonus.code));
  };
  const onBonusClick = (bonus: IBonus) => {
    trackBonusClicked(bonus.code);

    /** При наличии url для перехода вместо открытия модалки перейдет по ссылке **/
    if (bonus.aboutUrl) {
      navigateToPage(bonus.aboutUrl);

      return;
    }

    callBonusModal(bonus.about);
  };

  if (!bonuses?.length) {
    return null;
  }

  return (
    <Section dataName="BonusesSectionContainer" testId="BonusesSectionContainer">
      <ActionAfterViewed callback={onBonusesViewed}>
        <BonusesSection bonuses={bonuses} onBonusClick={onBonusClick} />
      </ActionAfterViewed>
      <BonusModal {...bonusModalProps} />
    </Section>
  );
};
